import { TextareaHTMLAttributes } from 'react';
import { TextareaField } from './styles';

export const Textarea = (
	props: TextareaHTMLAttributes<HTMLTextAreaElement>,
) => {
	return <TextareaField {...props} autoComplete="off" $width="97%" />;
};
